export default __webpack_public_path__ + "static/media/beer.bf48e562.png";